<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetValue',
  components: {widgetWrapper},
  emits: ['more', 'click'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, prefix, dateItem, lists, more, info} = items;
    const cLabel = resolveComponent('c-label')
    const legoChip = resolveComponent('lego-chip')
    const legoIcon = resolveComponent('lego-icon')
    const widgetWrapper = resolveComponent('widget-wrapper')


    const widgetDate = list =>
        h('div', {class: 'widget-value-list__date'}, [
          h(
              cLabel,
              {
                size: 16,
                color: list.point ? $theme.COLOR.PRIMARY.BASE : $theme.COLOR.UI.UI01,
              },
              [
                h('span', {class: 'widget-value-list__cost'}, [
                  list.type === 'cost' && list.currency,
                ]),
                h('span', {domProps: {innerHTML: this.localeString(list.value)}}),
              ],
          ),
        ]);

    const widgetMonitoring = list =>
        list.value.map(listItem => {
          return h(
              legoChip,
              {
                compact: true,
                statusColor: listItem.status,
              },
              () => [listItem.value],
          );
        });
    const nullList = h('div', {class: 'widget-null'}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 72,
        color: '#D6DCF4',
      }),
      h(
          cLabel,
          {
            size: 20,
            weight: 500,
          },
          () => ['참여 프로젝트가 없습니다.'],
      ),
    ]);

    const widgetList =
        lists.length > 0
            ? lists.map((list, idx) => {
              return h(
                  'div',
                  {
                    class: {
                      'widget-value-list': true,
                      'widget-value-default': list.type !== 'default',
                    },
                    style: {borderBottom: `1px solid ${$theme.COLOR.UI.UI10}`},
                    key: idx,
                  },
                  [
                    h('div', {class: 'widget-value-list__name'}, [
                      h(
                          cLabel,
                          {
                            pointer: this.$attrs.click ? true : false,
                            ellipsis: true,
                            size: 16,
                            color: list.point ? $theme.COLOR.PRIMARY.BASE : $theme.COLOR.UI.UI01,
                            onClick: () => {
                              this.$emit('click', list);
                            },
                          },
                          () => [list.name],
                      ),
                    ]),
                    list.type === 'monitoring' ? widgetMonitoring(list) : widgetDate(list),
                  ],
              );
            })
            : nullList;

    const widgetValue = h('div', {class: 'widget-value'}, [widgetList]);

    return h(
        widgetWrapper,
        {
          title, subtitle, prefix, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetValue],
    );
  },
  methods: {
    localeString(val) {
      return val.toLocaleString();
    },
  },
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-value {
  height: 100%;
  margin: 0 auto;
  padding: 29px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  .widget-null {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
    height: 100%;

    :deep.lego-icon {
      margin-bottom: 17px;
    }
  }

  &-list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    padding: 0 20px 8px 20px;

    &:nth-of-type(1) {
      margin-top: 0;
    }

    &:nth-last-of-type(1) {
      border: 0 !important;
    }

    &__cost {
      margin-right: 10px;
    }

    &__name {
      display: flex;
      flex: 1 1 auto;
    }

    &__value {
      text-align: right;
      flex: 1 1 auto;
    }
  }

  &-default {
    :deep .lego-chip__slot {
      font-size: 16px;
      font-weight: 500;
    }

    :deep .lego-chip__container {
      margin-left: 10px;
    }

    &__name {
      width: inherit;
    }

    &__value {
      width: inherit;
    }
  }

  :deep .error {
    color: var(--error);
  }
}
</style>
